import { MODAL_TYPE, useCapability, useCurrentModal } from '@nx/state';
import {
  ConnectionModal,
  DataSourceModal,
  GuideSelectionModal,
  InstanceNameDialog,
  PasswordChangeDialog,
} from '@nx/ui';

import { ExternalDataSources } from './external-data-sources';

export function UpxModals() {
  const [connectionHistoryEnabled] = useCapability('framework:connection-history');
  const modal = useCurrentModal();

  if (modal === null) {
    return null;
  }

  switch (modal.type) {
    case MODAL_TYPE.CONNECTION_FORM: {
      return (
        <ConnectionModal
          allowAliasChange={connectionHistoryEnabled}
          connectionSource={modal.source}
          instanceDetails={modal.instanceDetails}
          initialValues={modal.initialValues}
          initialWarning={modal.warning}
          initialError={modal.error}
        />
      );
    }

    case MODAL_TYPE.DATA_SOURCE: {
      return (
        <DataSourceModal
          dataSources={[
            {
              name: 'My Connections',
              element: <ExternalDataSources allowEdit={connectionHistoryEnabled} />,
            },
          ]}
        />
      );
    }

    case MODAL_TYPE.GUIDE_SELECTION: {
      return <GuideSelectionModal />;
    }

    case MODAL_TYPE.INSTANCE_NAME: {
      return <InstanceNameDialog />;
    }

    case MODAL_TYPE.PASSWORD_CHANGE: {
      return <PasswordChangeDialog passwordChangeRequired={modal.passwordChangeRequired} />;
    }

    default: {
      return null;
    }
  }
}
